<select class="chosen-select" #selectBox class=" form-control"   >
    <option *ngFor="let option of options" [value]="option.value">{{ option.label }}</option>
</select>
  